<template>
	<div class="order-data">
		<div class="bar-data border-right">Pedido No. {{ id }}</div>
		<div class="bar-data border-right">Comprado el {{ formatDate }}</div>
		<div class="bar-data">Total: {{ currencySymbol }}{{ formatAmount }}</div>
		<!-- <button class="print-data" type="button" @click="$emit('print-data')">
			<img src="/static/img/icons/printer.svg" alt="" height="31">
		</button> -->
	</div>
</template>

<script>
	import { format } from 'date-fns';

	function formatAmount() {
		if (this.amount) {
			return this.amount.toFixed(2);
		}
		return 0;
	}

	function formatDate() {
		return format(this.date, 'DD/MM/YY');
	}

	export default {
		name: 'order-data',
		computed: {
			formatAmount,
			formatDate,
		},
		props: {
			amount: [Number, String],
			currencySymbol: String,
			date: [Date, String, Number],
			id: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
	.order-data {
		align-items: center;
		display: flex;
	}

	.bar-data {
		font-family: font(avenirDemi);
		font-size: size(msmall);
		padding: 0px 14px;

		&.border-right {
			border-right: 1px solid color(titleGrey);
		}
	}

	.print-data {
		border: 0px;
		border-radius: 100%;
		height: 64px;
		width: 64px;
	}
</style>


// WEBPACK FOOTER //
// order-data.vue?56d3f54d